/**
 * Field identifier for dynamic task ID filters.
 *
 * This is NOT added to the FilterTypes enum or FilterFields map because:
 * - It's not a user-selectable predefined filter option
 * - It doesn't map to a real ITask property
 * - It doesn't need aria labels, filter counts, or menu rendering
 *
 * Used as the Filter.field discriminator in applyTaskFilter()
 * and for persistence exclusion during serialization.
 */ export const DynamicFilterField = "dynamicTaskIds";
/**
 * Filter fields excluded from cache persistence in this phase.
 * To enable persistence for a filter type, remove it from this set.
 */ export const NonPersistedFilterFields = new Set([
    DynamicFilterField
]);
/**
 * Maximum number of saved dynamic filters per scope (per user + per plan).
 * Enforced as admission control at save time by the action creator and as a hard
 * invariant by the store.
 */ export const MAX_DYNAMIC_FILTERS = 10;
/**
 * Maximum number of saved dynamic filters per user across all scopes (app-wide).
 */ export const MAX_DYNAMIC_FILTERS_TOTAL = 100;
